import { Injectable, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificationService, EcapTranslateService } from '../../core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { forEach } from 'lodash';
@Injectable()
export class TemplateAtlasSharedService {
    // used for showing in the chat box in real time
    private newMessageArrived = new Subject<any>();
    messageArrived = this.newMessageArrived.asObservable();
    // used for showing notifications in the panel
    private newUnreadMessageArrived = new Subject<any>();
    unreadMessageArrived = this.newUnreadMessageArrived.asObservable();
    // chat Details command
    private chatDetailsCommandArrived = new Subject<any>();
    chatDetailsCommand = this.chatDetailsCommandArrived.asObservable();
    // notification marked as read
    public notificationMarkRead = new EventEmitter<number>();
    // used for showing view all
    private newviewAllArrived = new Subject<any>();
    viewAllArrived = this.newviewAllArrived.asObservable();
    // setting current thread id for select assistant
    public currentSelectAssistantThreadId = new Subject<any>();
    updatedSelectAssistantThreadId = this.currentSelectAssistantThreadId.asObservable();

    // setting current thread id for floating chat panel
    public currentFloatingPanelThreadId = new Subject<any>();
    updatedFloatingPanelThreadId = this.currentFloatingPanelThreadId.asObservable();

    public counter = 0;
    private totalNotificationCounter: number = 0;
    // goto SLBot command
    private goToBotCommandArrived = new EventEmitter<boolean>();
    goToBotCommand = this.goToBotCommandArrived.asObservable();
    // open my account modal
    public openMyAccountModal = new EventEmitter<boolean>();
    // open my report modal
    public openReportModal = new EventEmitter<boolean>();
    // openAbout Modal
    public openAboutModal = new EventEmitter<boolean>();
    // new Notification arrival
    public newNotificationArrived = new EventEmitter<boolean>();

    private pageConfig = {
        pageNumber: 1,
        pageSize: 10
    };
    public isNewArrival: boolean;

    public Callback: any;
    public toobarCallback: any;
    private previousNotificationCounterStore = 0;
    public notificationConnectionResponseEvent: EventEmitter<any> = new EventEmitter<any>();
    public notificationFinUserDeletedEvent: EventEmitter<any> = new EventEmitter<any>();
    public notificationFinTransactionLoadedEvent: EventEmitter<any> = new EventEmitter<any>();
    public notificationConnectionUpdateResponseEvent: EventEmitter<any> = new EventEmitter<any>();

    // public imagePreviewEvent = new EventEmitter<boolean>();
    public static imagePreviewEvent = new EventEmitter<boolean>();
    // public static getImagePreviewEvent = TemplateAtlasSharedService.imagePreviewEvent.asObservable();

    constructor(
        private notificationService: NotificationService,
        private ecapTranslateService: EcapTranslateService,
        private snackBar: MatSnackBar
    ) {}

    /**
     * Title: notifyNewUnreadMessage
     * Description: notifying new unread message and sent all unread messages(always call first 10 notification)
     * param null
     * return array of notifications
     */
    notifyNewUnreadMessage(pageNumber?, pageSize?, OnlyUnread?, ResponseKeys?): any {
        this.pageConfig.pageNumber = 1; // will show only first page notification
        let notificationPayload = {
            OnlyUnread: true,
            OrderByCreatedDate: 1,
            ReturnCount: true,
            PageNumber: pageNumber ? pageNumber : this.pageConfig.pageNumber,
            PageSize: pageSize ? pageSize : this.pageConfig.pageSize
        };
        if (ResponseKeys) {
            notificationPayload['ResponseKeys'] = ResponseKeys;
        }

        if (!OnlyUnread) {
            notificationPayload.OnlyUnread = false;
        } else {
            notificationPayload.OnlyUnread = true;
        }

        this.notificationService.getAllNotification(notificationPayload).subscribe((result: any) => {
            this.totalNotificationCounter = result.body['TotalCount'];
            this.newUnreadMessageArrived.next({
                notifications: result.body.Data,
                total: this.totalNotificationCounter
            });
        });
        // this.newUnreadMessageArrived.next();
    }

    /**
     * Title: notifyNewUnreadMessage
     * Description: notifying new unread message and sent all unread messages
     * param null
     * return array of notifications
     */
    notifyAfterViewAll(OnlyUnread?, ResponseKeys?): any {
        this.pageConfig.pageNumber = this.pageConfig.pageNumber + 1;
        let notificationPayload = {
            OnlyUnread: true,
            OrderByCreatedDate: 1,
            ReturnCount: true,
            PageNumber: this.pageConfig.pageNumber,
            PageSize: 10
        };
        if (ResponseKeys) {
            notificationPayload['ResponseKeys'] = ResponseKeys;
        }
        if (!OnlyUnread) {
            notificationPayload.OnlyUnread = false;
        } else {
            notificationPayload.OnlyUnread = true;
        }
        this.notificationService.getAllNotification(notificationPayload).subscribe((result: any) => {
            this.newviewAllArrived.next({
                notifications: result.body.Data,
                total: this.totalNotificationCounter
            });
        });
        // this.newUnreadMessageArrived.next();
    }

    /**
     * Title:reshufleNotification
     * Description: redoing all the notifications and mark them as read after filter
     * param threadId
     * return
     */
    reshufleNotification(currentThreadId: string) {
        this.notificationService.getAllNotificationBySubscripFilter().subscribe(
            (res: any) => {
                const notificationIds = [];
                const threadId = currentThreadId;
                if (res) {
                    forEach(res, function (value, key) {
                        if (JSON.parse(value.Payload.ResponseValue).ThreadId === threadId && !value.IsRead) {
                            notificationIds.push(value.Id);
                        }
                    });
                }
                if (notificationIds && notificationIds.length) {
                    this.notificationService.markNotificationAsRead(notificationIds).subscribe(
                        (readResponse: any) => {
                            this.notificationService.getUnreadNotificationCounter().subscribe((counter: number) => {
                                this.notificationMarkAsRead(counter); // reshufling counter
                                this.notifyNewUnreadMessage(0, 10, true); // reloading the panels notifications
                            });
                        },
                        (err: any) => {
                            //  console.log(err);
                        }
                    );
                }
            },
            (error: any) => {
                // console.log(error);
            }
        );
    }

    /**
     * Title:markingNotificationsAsRead
     * Description: marking notification as read and then reload the notifications
     * param notificationIds[array]
     * return
     */
    markingNotificationsAsRead(notificationIds) {
        this.notificationService.markNotificationAsRead(notificationIds).subscribe(
            (readResponse: any) => {
                this.notificationService.getUnreadNotificationCounter().subscribe((counter: number) => {
                    this.notificationMarkAsRead(counter); // reshufling counter
                    this.notifyNewUnreadMessage(0, 10, true); // reloading the panels notifications
                });
            },
            (err: any) => {
                //   console.log(err);
            }
        );
    }

    // go to chat box
    sendNewArrivedMessageToChatBox(message): void {
        this.newMessageArrived.next(message);
    }

    // go to chat details view
    sendChatDetailsCommand(info) {
        this.chatDetailsCommandArrived.next(info);
    }

    // go to bot
    gotoBotCommand() {
        this.goToBotCommandArrived.emit(true);
    }

    // notification mark as read
    notificationMarkAsRead(counter) {
        this.notificationMarkRead.emit(counter);
    }

    // setting notification counter
    setCounter(counter) {
        if (this.previousNotificationCounterStore !== counter) {
            this.previousNotificationCounterStore = counter;
            this.counter = counter;
            this.newNotificationArrived.next(true);
        }
    }

    // getting notification counter
    getCounter() {
        return this.counter;
    }

    registerCallback(thisCallBack) {
        this.Callback = thisCallBack;
    }

    showSnackbar(message?) {
        this.Callback.openSnackBar(message);
    }

    registerToolbarCallBack(toobarCallBack) {
        this.toobarCallback = toobarCallBack;
    }

    subscribeForMessaingNotification() {
        this.toobarCallback && this.toobarCallback.subscribeForMessageNotification();
    }

    public static changePreview(isPreview) {
        TemplateAtlasSharedService.imagePreviewEvent.emit(isPreview);
    }

    public static getChangePreview() {
        return TemplateAtlasSharedService.imagePreviewEvent;
    }

    /**
     * Title:denormalizeNotification
     * Description: denormalizing notifications
     * param notifications
     * return
     */
    denormalizeNotification(notificationArray: any[]) {
        const isJSON = this.isJSON;
        const that = this;

        forEach(notificationArray, function (notification) {
            notification.DenormalizedPayload =
                notification && notification.DenormalizedPayload
                    ? isJSON(notification.DenormalizedPayload)
                        ? JSON.parse(notification.DenormalizedPayload)
                        : notification.DenormalizedPayload
                    : {};
            if (notification.DenormalizedPayload && notification.DenormalizedPayload.messageKey) {
                notification.DenormalizedPayload['message'] = that.replacePlaceholderValues(
                    that.ecapTranslateService.instantTranslate(notification.DenormalizedPayload.messageKey),
                    notification.DenormalizedPayload
                );
            } else if (notification.DenormalizedPayload && notification.DenormalizedPayload.key) {
                if (typeof notification.DenormalizedPayload.message === 'object') {
                    notification.DenormalizedPayload.messageObj = JSON.parse(
                        JSON.stringify(notification.DenormalizedPayload.message)
                    );
                }
                notification.DenormalizedPayload['message'] = that.replacePlaceholderValues(
                    that.ecapTranslateService.instantTranslate(notification.DenormalizedPayload.key),
                    notification.DenormalizedPayload.messageObj
                );
            } else if (
                notification.DenormalizedPayload &&
                notification.DenormalizedPayload.Message &&
                notification.DenormalizedPayload.Message.indexOf(' ') <= -1
            ) {
                notification.DenormalizedPayload['message'] = that.replacePlaceholderValues(
                    that.ecapTranslateService.instantTranslate(notification.DenormalizedPayload.Message),
                    notification.DenormalizedPayload
                );
            }
        });
        return notificationArray;
    }

    replacePlaceholderValues(text, valueObj) {
        forEach(valueObj, function (value, key) {
            if (key === 'Type') {
                value = value.split(',').join(', ');
            }
            text = text.split('[' + key + ']').join(value);
        });
        return text;
    }

    isJSON(str) {
        try {
            const obj = JSON.parse(str);
            if (obj && typeof obj === 'object' && obj !== null) {
                return true;
            }
        } catch (err) {}
        return false;
    }
}
